<template>
  <v-dialog v-model="dialog" scrollable persistent :max-width="800" :fullscreen="esMovil">
    <template v-slot:activator="{ on }">
      <v-tooltip v-if="!usuario" bottom>
        <template v-slot:activator="{on}">
          <v-btn color="grey lighten-3" class="grey--text mr-3" :ripple="false" active-class="" v-on="on">
            {{ $t("informe_perso") | capitalize }}
          </v-btn>
        </template>
        <span>{{ $t("error_registro") | capitalize }}</span>
      </v-tooltip>
      <v-btn v-else color="primary" v-on="on" class="inline-block mr-3">
        {{ $t("informe_perso") | capitalize }}
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="primary white--text pa-2">
        <v-btn color="error" class="hidden-md-and-up" icon @click="cerrarDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        {{ $t("informe_perso") }}
        <v-spacer class="hidden-md-and-up"/>
      </v-card-title>

      <v-card-text class="pt-0">
        <v-text-field v-model="nombre" :label="$t('nombre_informe') | capitalize" hide-details/>

        <v-text-field :value="$t('indicadores_explicacion') | capitalize" readonly hide-details/>

        <v-treeview v-model="indicadoresSeleccionados" :items="indicadoresParseados" selectable
                    selected-color="primary">
        </v-treeview>
        <v-skeleton-loader v-show="indicadoresParseados.length === 0 && cargandoIndicadores"
                           v-for="i in 3" :key="`indi-skl-${i}`" type="list-item"/>
      </v-card-text>

      <v-divider/>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="error" text @click="cerrarDialog">
          {{ $t("cerrar") | capitalize }}
        </v-btn>
        <v-btn color="primary" depressed :disabled="!valido" :loading="descargandoInforme" @click="descargarInforme">
          {{ $t("descargar") | capitalize }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapState} from 'vuex';
import {HttpHelper} from "@/comunes/helpers/HttpHelper";
import {MOSTRAR_SNACKBAR} from "@/store/store-app";

export default {
  name: "BtnInformePersonalizado",
  props: {
    proyecto: {required: true, type: Object},
    tipo: {required: true, type: String}
  },
  data: () => ({
    cargandoIndicadores: false,
    cargando: false,
    dialog: false,
    respuestaIndicadores: null,
    nombre: "",
    indicadoresSeleccionados: [],
    descargandoInforme: false
  }),
  computed: {
    ...mapState(["usuario"]),
    esMovil() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    indicadoresParseados() {
      if (!this.respuestaIndicadores) return [];

      const items = [];

      this.respuestaIndicadores.forEach((areaIndicadores) => {
        const hijos = [];
        if (areaIndicadores.indicadores) {
          areaIndicadores.indicadores.forEach((indicador) => {
            hijos.push({
              id: indicador.codigo,
              name: indicador.nombre
            });
          });
        } else {
          areaIndicadores.gruposIndicadores.forEach((grupoIndicador) => {
            const hijosGrupo = [];

            grupoIndicador.indicadores.forEach((indicador) => {
              hijosGrupo.push({
                id: indicador.codigo,
                name: indicador.nombre
              });
            });

            hijos.push({
              id: grupoIndicador.codigo,
              name: grupoIndicador.nombre,
              children: hijosGrupo
            });
          });
        }

        items.push({
          id: areaIndicadores.area.clase,
          name: areaIndicadores.area.nombre,
          children: hijos
        });
      })

      return items;
    },
    valido() {
      return this.nombre.length > 0 && this.indicadoresSeleccionados.length > 0;
    }
  },
  watch: {
    dialog(val) {
      if (val) this.cargarIndicadores();
    }
  },
  methods: {
    cerrarDialog() {
      this.nombre = "";
      this.indicadoresSeleccionados = [];
      this.dialog = false;
    },
    cargarIndicadores() {
      this.cargandoIndicadores = true;
      HttpHelper.get(`proyecto/${this.proyecto.id}/indicadores-informe-personalizado`)
          .then((data) => {
            this.respuestaIndicadores = data;
          })
          .finally(() => {
            this.cargandoIndicadores = false;
          })
    },
    async descargarInforme() {
      this.descargandoInforme = true;

      const descripciones = {};
      for (const sc of this.proyecto.solucionesConstructivas) {
        const descripcionSC = await HttpHelper.get(`solucion-constructiva/${sc.id}/descripcion`);
        const descripcionProcesada = await window.DescripcionesCeramica.generar(this.proyecto.id, sc.id,
            descripcionSC.contenido);
        if (sc.comparisonPriority.clase === "ceramica") descripciones.primaria = descripcionProcesada;
        else descripciones.secundaria = descripcionProcesada;
      }

      HttpHelper.post(`proyecto/${this.proyecto.id}/descargar-informe-personalizado`, {
        nombre: this.nombre,
        indicadores: this.indicadoresSeleccionados,
        tipo: this.tipo,
        descripciones: descripciones
      }).then((res) => {
        window.open(res.url, "_blank");
        this.$store.commit(MOSTRAR_SNACKBAR, {
          texto: this.$t("informe_generado"),
          color: "info"
        });
        this.cerrarDialog();
      }).finally(() => {
        this.descargandoInforme = false;
      });
    }
  }
}
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
{
  "es": {
    "informe_perso": "informe personalizado",
    "error_registro": "registrate o inicia sesión para descargarte el informe personalizado",
    "nombre_informe": "nombre del informe",
    "indicadores_explicacion": "seleccione la información que quiere que aparezca en el informe de descarga",
    "informe_generado": "Informe generado",
    "descargar": "descargar"
  }
}
</i18n>
<!--@formatter:on-->